import { render, staticRenderFns } from "./PaySuccess.vue?vue&type=template&id=1660afae&scoped=true&"
import script from "./PaySuccess.vue?vue&type=script&lang=ts&"
export * from "./PaySuccess.vue?vue&type=script&lang=ts&"
import style0 from "./PaySuccess.vue?vue&type=style&index=0&id=1660afae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1660afae",
  null
  
)

export default component.exports